/**
 * Leasing-Api
 * 1.0.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from "@oazapfts/runtime";
import * as QS from "@oazapfts/runtime/query";
export const defaults: Oazapfts.Defaults<Oazapfts.CustomHeaders> = {
    headers: {},
    baseUrl: "/",
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {};
export type ConnectUserRequest = {
    pWSFNUser: string | null;
    pPassword: string | null;
};
export type StringODataResponse = {
    odataContext?: string | null;
    value?: string | null;
};
export type StringODataResponseResult = {
    isSuccess?: boolean;
    data?: StringODataResponse;
    errorMessage?: string | null;
    statusCode?: number;
};
export type AuthenticationStatusModel = {
    isMitIDAuthenticated?: boolean;
    isFFAuthenticated?: boolean;
};
export type NewLeasingRequest = {
    /** M1, M2, M3, M4, M6, M12 */
    interestPaymentFrequency?: string | null;
    principalAmount?: number;
    /** KKFast = fasst rente, KKVar = variabel rente, KKCibor = variabal med en anden rente */
    loanProduct?: string | null;
    amortizationProfile?: string | null;
    /** Hvor meget kan jeg få ved udløb */
    scrap?: number;
    numberOfPayments?: number;
    /** Førstegangsydelse (valgfri) */
    fixedFirstPayment?: number;
};
export type DeliveryApprovalModel = {
    oDataEtag?: string | null;
    wsfnCompany?: string | null;
    wsfnUser?: string | null;
    contractNo?: string | null;
    generation?: number;
    customerNo?: string | null;
    parameterA?: string | null;
    parameterB?: string | null;
    customerName?: string | null;
    customerName2?: string | null;
    vendorName?: string | null;
    vendorName2?: string | null;
    amount?: number;
    description?: string | null;
    documentNo?: string | null;
    entryNo?: number;
    documentType?: string | null;
    leasingObjectID?: string | null;
    deliveryContact?: string | null;
    agreedPurchasePrice?: number;
    externalDocumentNo?: string | null;
};
export type ProblemDetails = {
    "type"?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    [key: string]: any;
};
export type AcceptDeliveryRequest = {
    /** pAno indicates if the user is anonymus (Has no FF12 user). If true user is not validated in FF12. */
    pAno: boolean;
    /** pVLEEntry is the document ref to accept/reject. Equals the Entry_no parameter from the deliverylist. */
    pVLEEntry: number;
    pMoveToContract?: string | null;
    pMoveContract?: boolean;
};
export type RejectDeliveryRequest = {
    /** pAno indicates if the user is anonymus (Has no FF12 user). If true user is not validated in FF12. */
    pAno: boolean;
    /** pVLEEntry is the document ref to accept/reject. Equals the Entry_no parameter from the deliverylist. */
    pVLEEntry: number;
    pCause: string | null;
};
export type DocumentModel = {
    oDataEtag?: string | null;
    documentNo?: string | null;
    groupNo?: string | null;
    filename?: string | null;
    currentRevision?: number;
    modifiedDate?: string;
    fileType?: string | null;
};
export type DraftModel = {
    oDataEtag?: string | null;
    wsfnCompany?: string | null;
    wsfnUser?: string | null;
    uuid?: string | null;
    contractNo?: string | null;
    blob?: string | null;
    modifiedDate?: string;
    creationDate?: string;
};
export type NewDraftRequest = {
    pBlob?: string | null;
};
export type UpdateDraftRequest = {
    pContractNo?: string | null;
    pBlob?: string | null;
};
export type ExpiringAgreementModel = {
    oDataEtag?: string | null;
    wsfnCompany?: string | null;
    wsfnUser?: string | null;
    contractNo?: string | null;
    generation?: number;
    entryNo?: number;
    entryDate?: string;
    contractProfile?: string | null;
    matureCode?: string | null;
    customerNo?: string | null;
    customerContact?: string | null;
    customerContactName?: string | null;
    contractStatus?: string | null;
    periodEnd?: string;
    contractDescription?: string | null;
    residualValueDueDate?: string;
    residualValueInclVAT?: number;
    residualValueExclVAT?: number;
    registrationNo?: string | null;
    leaseplan?: boolean;
    latestEntry?: boolean;
    netInvestmentLCY?: number;
    responseDatetime?: string;
    responseMatureCode?: string | null;
    customerName?: string | null;
    customerName2?: string | null;
    customerAddress?: string | null;
    customerAddress2?: string | null;
    customerPostCode?: string | null;
    customerCity?: string | null;
    customerMail?: string | null;
    customerVATRegNo?: string | null;
    customerEANNo?: string | null;
    contractGLNNo?: string | null;
};
export type ExpiringAgreementExtendFrontendModel = {
    pContractProfile?: string | null;
    pContractList?: string | null;
    pVATRegNo?: string | null;
    pProlongKM?: number;
    pProlongDate?: string;
    pRemark?: string | null;
};
export type ExpiringAgreementPurchaseFrontendModel = {
    pContractProfile?: string | null;
    pContractList?: string | null;
    pPNumber?: string | null;
};
export type ExpiringAgreementSaleFrontendModel = {
    pContractProfile?: string | null;
    pContractList?: string | null;
    pBuyerName?: string | null;
    pBuyerContact?: string | null;
    pBuyerAddress?: string | null;
    pBuyerPostCode?: string | null;
    pBuyerCity?: string | null;
    pBuyerMail?: string | null;
    pVATRegNo?: string | null;
    pPNumber?: string | null;
    pEANNumber?: string | null;
    pPhoneNo?: string | null;
    pPickupFromDate?: string;
};
export type ExpiringAgreementAyvensFrontendModel = {
    pContractProfile?: string | null;
    pContractList?: string | null;
    pBuyerContact?: string | null;
    pBuyerAddress?: string | null;
    pBuyerPostCode?: string | null;
    pBuyerCity?: string | null;
    pPhoneNo?: string | null;
    pPickupFromDate?: string;
    pCanStartAndDrive?: boolean;
    pHasBeenDamaged?: boolean;
    pRepairAboveThresshold?: boolean;
};
export type FrameworkModel = {
    oDataEtag?: string | null;
    wsfnCompany?: string | null;
    wsfnUser?: string | null;
    code?: string | null;
    expirationDate?: string;
    createdDate?: string;
    description?: string | null;
    limit?: number;
    balanceLcy?: number;
    totalAcquisition?: number;
    expired?: boolean;
    masterCode?: string | null;
    amountDiff?: number;
    atDisposalAmount?: number;
    defaultTermsinMonthsBQS?: number;
    minTermsinMonthsBQS?: number;
    maxTermsInMonthsBQS?: number;
    defaultFrequencyBQS?: number;
    onlyFixedInterest?: number;
    onlyVariableInterest?: number;
};
export type FrameworkShortModel = {
    code?: string | null;
    description?: string | null;
    atDisposalAmount?: number;
    defaultTermsinMonthsBQS?: number;
    defaultFrequencyBQS?: number;
    minTermsinMonthsBQS?: number;
    maxTermsInMonthsBQS?: number;
    onlyFixedInterest?: number;
    onlyVariableInterest?: number;
};
export type FrameworkByMasterModel = {
    oDataEtag?: string | null;
    code?: string | null;
    customerNo?: string | null;
    mainEngagementNo?: string | null;
    expirationDate?: string;
    description?: string | null;
    atDisposalAmount?: number;
    allocatedAmount?: number;
};
export type GlnModel = {
    oDataEtag?: string | null;
    customerNo?: string | null;
    gln?: string | null;
    active?: boolean;
};
export type LeasingModel = {
    oDataEtag?: string | null;
    wsfnCompany?: string | null;
    wsfnUser?: string | null;
    contractNo?: string | null;
    generation?: number;
    leasingObjectId?: string | null;
    groupCode?: string | null;
    customerNo?: string | null;
    status?: string | null;
    contractProfile?: string | null;
    noOfLo?: number;
    description?: string | null;
    description2?: string | null;
    periodEnd?: string;
    periodEndTag?: string | null;
    frequency?: string | null;
    termInMonths?: number;
    archiveDate?: string;
    firstDueDate?: string;
    dueDate?: string;
    lastDueDate?: string;
    purchasePrice?: number;
    financeAmount?: number;
    residualValueLcy?: number;
    customerName?: string | null;
    customerName2?: string | null;
    engagementTypeCaption?: string | null;
    registrationNo?: string | null;
    expirationCustomerName?: string | null;
    isExpirationCust?: number;
    expirationCustomerCode?: string | null;
    masterGroupCode?: string | null;
    eanNo?: string | null;
    customerContact?: string | null;
    deliveryContact?: string | null;
    correspondenceContact?: string | null;
    contractResponsible1?: string | null;
    baseInterestType?: string | null;
    fixedInterestRate?: boolean;
    orderNo?: string | null;
    periodStart?: string | null;
    createdDate?: string;
    atDisposal?: number;
    totalInvoiced?: number;
    inceptionDate?: string;
    nextPayment?: number;
    reference?: string | null;
    accountString?: string | null;
    netInvestment?: number;
    acquisition?: number;
    totalInitPmt?: number;
    postedInitPmt?: number;
};
export type UpdateEanRequest = {
    pContractNo?: string | null;
    pGeneration?: number;
    pNewEANValue?: string | null;
};
export type UpdateReferenceRequesst = {
    pContractNo?: string | null;
    pGeneration?: number;
    pNewReferenceValue?: string | null;
};
export type UpdateAccountStringRequest = {
    pContractNo?: string | null;
    pGeneration?: number;
    pNewAccountStringValue?: string | null;
};
export type PaymentModel = {
    oDataEtag?: string | null;
    wsfnCompany?: string | null;
    wsfnUser?: string | null;
    generation?: number;
    contractPaymentGeneration?: string;
    contractNo?: string | null;
    dueDate?: string;
    payment?: number;
    interest?: number;
    repayment?: number;
    netInvestment?: number;
    showAllGenerations?: number;
};
export type LeasingObjectModel = {
    oDataEtag?: string | null;
    contractNo?: string | null;
    generation?: number;
    leasingObjectId?: string | null;
    description?: string | null;
    agreedPurchasePrice?: number;
    vendorName?: string | null;
    initPmtInceptionDate?: string;
    description2?: string | null;
    postedPurchDocumentType?: string | null;
    serialNo?: string | null;
    plannedQtyKm?: number;
    licensePlateType?: string | null;
    approved?: boolean;
    licensePlateNo?: string | null;
    registrationNo?: string | null;
    initPmtInceptionDateText?: string | null;
    lastOnHoldReason?: string | null;
};
export type LeasingObjectEntryModel = {
    oDataEtag?: string | null;
    entryNo?: number;
    leasingObjectId?: string | null;
    documentDate?: string;
    documentType?: string | null;
    documentNo?: string | null;
    amountLcy?: number;
    documentTypeValue?: number;
    externalDocumentNo?: string | null;
};
export type MasterModel = {
    oDataEtag?: string | null;
    wsfnCompany?: string | null;
    wsfnUser?: string | null;
    code?: string | null;
    customerNo?: string | null;
    expirationDate?: string;
    description?: string | null;
    atDisposalAmount?: number;
    limit?: number;
    createdDate?: string;
    expired?: boolean;
    allocatedAmount?: number;
};
export type ContactModel = {
    oDataEtag?: string | null;
    code?: string | null;
    name?: string | null;
    email?: string | null;
};
export type CustomerModel = {
    oDataEtag?: string | null;
    code?: string | null;
    name?: string | null;
    name2?: string | null;
    eMail?: string | null;
    address?: string | null;
};
export type CategoryModel = {
    oDataEtag?: string | null;
    code?: string | null;
    description?: string | null;
};
export type NewAggrementRequest = {
    pContractNo?: string | null;
    pBlob?: string | null;
};
/**
 * Starts the OIDC sign-in process.
 */
export function getApiV1AuthenticateSignin(returnUrl: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/api/v1/authenticate/signin${QS.query(QS.explode({
        returnUrl
    }))}`, {
        ...opts
    }));
}
/**
 * login and connect user to FF12. Used on first login to connect MITID user to FF12 user.
 */
export function postApiV1AuthenticateConnectuser(connectUserRequest?: ConnectUserRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: StringODataResponseResult;
    } | {
        status: 401;
        data: StringODataResponseResult;
    }>("/api/v1/authenticate/connectuser", oazapfts.json({
        ...opts,
        method: "POST",
        body: connectUserRequest
    })));
}
/**
 * Starts the OIDC sign-out process.
 */
export function getApiV1AuthenticateSignout(returnUrl: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: StringODataResponseResult;
    }>(`/api/v1/authenticate/signout${QS.query(QS.explode({
        returnUrl
    }))}`, {
        ...opts
    }));
}
/**
 * Returns the name of the logged in MITID user.
 */
export function getApiV1AuthenticateGetUserName(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: StringODataResponseResult;
    } | {
        status: 401;
        data: StringODataResponseResult;
    }>("/api/v1/authenticate/getUserName", {
        ...opts
    }));
}
/**
 * Returns an authentication status object.
 */
export function getApiV1AuthenticateGetAuthenticationStatus(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AuthenticationStatusModel;
    }>("/api/v1/authenticate/getAuthenticationStatus", {
        ...opts
    }));
}
/**
 * Create a new CalculationPath for StandAlone
 */
export function putCalculatorCreatepath(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/calculator/createpath", {
        ...opts,
        method: "PUT"
    }));
}
/**
 * Add a new event to an existing calculation given a calculation path. Receive a new calculation path on the updated calculation
 */
export function putCalculatorNewleasingByPath(path: string, newLeasingRequest?: NewLeasingRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/calculator/newleasing/${encodeURIComponent(path)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: newLeasingRequest
    })));
}
/**
 * Fetch a stored calculation by calculation path from storage account
 */
export function getCalculatorCalculationresultByCalculationPath(calculationPath: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/calculator/calculationresult/${encodeURIComponent(calculationPath)}`, {
        ...opts
    }));
}
/**
 * Get all leasings
 */
export function getApiV1Deliveryapproval(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DeliveryApprovalModel[];
    }>("/api/v1/deliveryapproval", {
        ...opts
    }));
}
/**
 * Get a single delivery approval by entry number
 */
export function getApiV1DeliveryapprovalByEntryNo(entryNo: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DeliveryApprovalModel;
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/deliveryapproval/${encodeURIComponent(entryNo)}`, {
        ...opts
    }));
}
/**
 * Get a single delivery approval from paramA and paramB, when user is anonymous (not authenticated using a deeplink)
 */
export function getApiV1DeliveryapprovalByParamAAndParamB(paramA: string, paramB: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DeliveryApprovalModel;
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/deliveryapproval/${encodeURIComponent(paramA)}/${encodeURIComponent(paramB)}`, {
        ...opts
    }));
}
/**
 * Accept delivery approval
 */
export function postApiV1DeliveryapprovalAccept(acceptDeliveryRequest: AcceptDeliveryRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 204;
    } | {
        status: 404;
        data: ProblemDetails;
    }>("/api/v1/deliveryapproval/accept", oazapfts.json({
        ...opts,
        method: "POST",
        body: acceptDeliveryRequest
    })));
}
export function postApiV1DeliveryapprovalReject(rejectDeliveryRequest: RejectDeliveryRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 404;
        data: ProblemDetails;
    }>("/api/v1/deliveryapproval/reject", oazapfts.json({
        ...opts,
        method: "POST",
        body: rejectDeliveryRequest
    })));
}
/**
 * Get all annual statements
 */
export function getApiV1DocumentsAnnualStatements(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DocumentModel[];
    } | {
        status: 404;
        data: ProblemDetails;
    }>("/api/v1/documents/AnnualStatements", {
        ...opts
    }));
}
/**
 * Get all documents by master code
 */
export function getApiV1DocumentsBymasterByMasterCode(masterCode: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DocumentModel[];
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/documents/bymaster/${encodeURIComponent(masterCode)}`, {
        ...opts
    }));
}
/**
 * Get all documents by framework code
 */
export function getApiV1DocumentsByframeworkByFrameworkCode(frameworkCode: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DocumentModel[];
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/documents/byframework/${encodeURIComponent(frameworkCode)}`, {
        ...opts
    }));
}
/**
 * Get all documents by leasing
 */
export function getApiV1DocumentsByleasingByContractNo(contractNo: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DocumentModel[];
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/documents/byleasing/${encodeURIComponent(contractNo)}`, {
        ...opts
    }));
}
/**
 * Get all documents by leasing objects
 */
export function getApiV1DocumentsByleasingObjectsByContractNo(contractNo: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DocumentModel[];
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/documents/byleasingObjects/${encodeURIComponent(contractNo)}`, {
        ...opts
    }));
}
/**
 * Get all documents by leasing object code
 */
export function getApiV1DocumentsByleasingobjectByLeasingObjectCode(leasingObjectCode: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DocumentModel[];
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/documents/byleasingobject/${encodeURIComponent(leasingObjectCode)}`, {
        ...opts
    }));
}
/**
 * Get file
 */
export function getApiV1DocumentsDownload({ documentNo, filename }: {
    documentNo?: string;
    filename?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: ProblemDetails;
    } | {
        status: 404;
        data: ProblemDetails;
    } | {
        status: 500;
    } | {
        status: 502;
    }>(`/api/v1/documents/download${QS.query(QS.explode({
        documentNo,
        filename
    }))}`, {
        ...opts
    }));
}
/**
 * Get invoice file
 */
export function getApiV1DocumentsDownloadInvoice({ documentNo, documentType }: {
    documentNo?: string;
    documentType?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: ProblemDetails;
    } | {
        status: 404;
        data: ProblemDetails;
    } | {
        status: 500;
    } | {
        status: 502;
    }>(`/api/v1/documents/downloadInvoice${QS.query(QS.explode({
        documentNo,
        documentType
    }))}`, {
        ...opts
    }));
}
export function getApiV1DraftsAll(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DraftModel[];
    }>("/api/v1/drafts/all", {
        ...opts
    }));
}
export function postApiV1DraftsNew(newDraftRequest: NewDraftRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/api/v1/drafts/new", oazapfts.json({
        ...opts,
        method: "POST",
        body: newDraftRequest
    })));
}
export function postApiV1DraftsUpdate(updateDraftRequest: UpdateDraftRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/api/v1/drafts/update", oazapfts.json({
        ...opts,
        method: "POST",
        body: updateDraftRequest
    })));
}
export function getApiV1DraftsGet({ contractId }: {
    contractId?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/api/v1/drafts/get${QS.query(QS.explode({
        contractId
    }))}`, {
        ...opts
    }));
}
export function getApiV1DraftsDelete({ contractId }: {
    contractId?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/api/v1/drafts/delete${QS.query(QS.explode({
        contractId
    }))}`, {
        ...opts
    }));
}
/**
 * Get all normal expiring agreements
 */
export function getApiV1ExpiringagreementsAllnormal(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExpiringAgreementModel[];
    }>("/api/v1/expiringagreements/allnormal", {
        ...opts
    }));
}
/**
 * Get all normal expiring agreements anonymous
 */
export function getApiV1ExpiringagreementsAllnormalanoByParamAAndParamBParamP(paramA: string, paramB: string, paramP: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExpiringAgreementModel[];
    }>(`/api/v1/expiringagreements/allnormalano/${encodeURIComponent(paramA)}/${encodeURIComponent(paramB)}/${encodeURIComponent(paramP)}`, {
        ...opts
    }));
}
/**
 * Get all ayvens expiring agreements e.g. Leaseplan
 */
export function getApiV1ExpiringagreementsAllayvens(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExpiringAgreementModel[];
    }>("/api/v1/expiringagreements/allayvens", {
        ...opts
    }));
}
/**
 * Get all ayvens expiring agreements anonymous e.g. Leaseplan
 */
export function getApiV1ExpiringagreementsAllayvensanoByParamAAndParamBParamP(paramA: string, paramB: string, paramP: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExpiringAgreementModel[];
    }>(`/api/v1/expiringagreements/allayvensano/${encodeURIComponent(paramA)}/${encodeURIComponent(paramB)}/${encodeURIComponent(paramP)}`, {
        ...opts
    }));
}
/**
 * Get all handled expiring agreements
 */
export function getApiV1ExpiringagreementsAllhandled(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExpiringAgreementModel[];
    }>("/api/v1/expiringagreements/allhandled", {
        ...opts
    }));
}
/**
 * Extending aggrement anonymous
 */
export function postApiV1ExpiringagreementsExtendano(expiringAgreementExtendFrontendModel: ExpiringAgreementExtendFrontendModel, { paramA, paramB }: {
    paramA?: string;
    paramB?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/expiringagreements/extendano${QS.query(QS.explode({
        paramA,
        paramB
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: expiringAgreementExtendFrontendModel
    })));
}
/**
 * Extending aggrement
 */
export function postApiV1ExpiringagreementsExtend(expiringAgreementExtendFrontendModel: ExpiringAgreementExtendFrontendModel, { entryId }: {
    entryId?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/expiringagreements/extend${QS.query(QS.explode({
        entryId
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: expiringAgreementExtendFrontendModel
    })));
}
/**
 * Purchase agreement anonymous
 */
export function postApiV1ExpiringagreementsPurchaseano(expiringAgreementPurchaseFrontendModel: ExpiringAgreementPurchaseFrontendModel, { paramA, paramB }: {
    paramA?: string;
    paramB?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/expiringagreements/purchaseano${QS.query(QS.explode({
        paramA,
        paramB
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: expiringAgreementPurchaseFrontendModel
    })));
}
/**
 * Purchase agreement
 */
export function postApiV1ExpiringagreementsPurchase(expiringAgreementPurchaseFrontendModel: ExpiringAgreementPurchaseFrontendModel, { entryId }: {
    entryId?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/expiringagreements/purchase${QS.query(QS.explode({
        entryId
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: expiringAgreementPurchaseFrontendModel
    })));
}
/**
 * Sale aggreement anonymous
 */
export function postApiV1ExpiringagreementsSaleano(expiringAgreementSaleFrontendModel: ExpiringAgreementSaleFrontendModel, { paramA, paramB }: {
    paramA?: string;
    paramB?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/expiringagreements/saleano${QS.query(QS.explode({
        paramA,
        paramB
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: expiringAgreementSaleFrontendModel
    })));
}
/**
 * Sale aggreement
 */
export function postApiV1ExpiringagreementsSale(expiringAgreementSaleFrontendModel: ExpiringAgreementSaleFrontendModel, { entryId }: {
    entryId?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/expiringagreements/sale${QS.query(QS.explode({
        entryId
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: expiringAgreementSaleFrontendModel
    })));
}
/**
 * Ayvens anonymous
 */
export function postApiV1ExpiringagreementsAyvensano(expiringAgreementAyvensFrontendModel: ExpiringAgreementAyvensFrontendModel, { paramA, paramB }: {
    paramA?: string;
    paramB?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/expiringagreements/ayvensano${QS.query(QS.explode({
        paramA,
        paramB
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: expiringAgreementAyvensFrontendModel
    })));
}
/**
 * Ayvens
 */
export function postApiV1ExpiringagreementsAyvens(expiringAgreementAyvensFrontendModel: ExpiringAgreementAyvensFrontendModel, { entryId }: {
    entryId?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/expiringagreements/ayvens${QS.query(QS.explode({
        entryId
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: expiringAgreementAyvensFrontendModel
    })));
}
/**
 * Get all framework aggrements
 */
export function getApiV1Frameworks({ includeExpired }: {
    includeExpired?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: FrameworkModel[];
    }>(`/api/v1/frameworks${QS.query(QS.explode({
        includeExpired
    }))}`, {
        ...opts
    }));
}
/**
 * Get all framework aggrements short form (code and description)
 */
export function getApiV1FrameworksShorts(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: FrameworkShortModel[];
    }>("/api/v1/frameworks/shorts", {
        ...opts
    }));
}
/**
 * Get a single framework aggrement by framework code
 */
export function getApiV1FrameworksByFrameworkCode(frameworkCode: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: FrameworkModel;
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/frameworks/${encodeURIComponent(frameworkCode)}`, {
        ...opts
    }));
}
/**
 * Get all framework aggrements by master code
 */
export function getApiV1FrameworksBymasterByMasterCode(masterCode: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: FrameworkByMasterModel[];
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/frameworks/bymaster/${encodeURIComponent(masterCode)}`, {
        ...opts
    }));
}
/**
 * Get all gln
 */
export function getApiV1GlnByCustomerNo(customerNo: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: GlnModel[];
    }>(`/api/v1/gln/${encodeURIComponent(customerNo)}`, {
        ...opts
    }));
}
/**
 * Get all EAN including main debitor. This is a special endpoint that also includes EAN numbers from main debitor (primarely used for NewAgreement)
 */
export function getApiV1GlnBymaindebitorByCustomerNo(customerNo: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: GlnModel[];
    }>(`/api/v1/gln/bymaindebitor/${encodeURIComponent(customerNo)}`, {
        ...opts
    }));
}
/**
 * Get all leasings
 */
export function getApiV1Leasings(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: LeasingModel[];
    }>("/api/v1/leasings", {
        ...opts
    }));
}
/**
 * Get a single leasing by leasing code
 */
export function getApiV1LeasingsByLeasingCode(leasingCode: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: LeasingModel;
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/leasings/${encodeURIComponent(leasingCode)}`, {
        ...opts
    }));
}
/**
 * Get all leasings by framework aggrements code
 */
export function getApiV1LeasingsByframeworkByFrameworkCode(frameworkCode: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: LeasingModel[];
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/leasings/byframework/${encodeURIComponent(frameworkCode)}`, {
        ...opts
    }));
}
/**
 * Get all leasings by customer number
 */
export function getApiV1LeasingsBycustomerByCustomerNumber(customerNumber: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: LeasingModel[];
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/leasings/bycustomer/${encodeURIComponent(customerNumber)}`, {
        ...opts
    }));
}
/**
 * Update leasing EAN number
 */
export function postApiV1LeasingsUpdateean(updateEanRequest: UpdateEanRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 404;
        data: ProblemDetails;
    }>("/api/v1/leasings/updateean", oazapfts.json({
        ...opts,
        method: "POST",
        body: updateEanRequest
    })));
}
/**
 * Update leasing reference
 */
export function postApiV1LeasingsUpdatereference(updateReferenceRequesst: UpdateReferenceRequesst, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 404;
        data: ProblemDetails;
    }>("/api/v1/leasings/updatereference", oazapfts.json({
        ...opts,
        method: "POST",
        body: updateReferenceRequesst
    })));
}
/**
 * Update leasing account string
 */
export function postApiV1LeasingsUpdateaccount(updateAccountStringRequest: UpdateAccountStringRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 404;
        data: ProblemDetails;
    }>("/api/v1/leasings/updateaccount", oazapfts.json({
        ...opts,
        method: "POST",
        body: updateAccountStringRequest
    })));
}
/**
 * Get leasing contract payments
 */
export function getApiV1LeasingsPayments({ contractId, generation, showAllGenerations }: {
    contractId?: string;
    generation?: number;
    showAllGenerations?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PaymentModel[];
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/leasings/payments${QS.query(QS.explode({
        contractId,
        generation,
        showAllGenerations
    }))}`, {
        ...opts
    }));
}
/**
 * Get a single Leasing object
 */
export function getApiV1Leasingobjects(leasingCode: string, leasingObjectCode: string, generation: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: LeasingObjectModel;
    }>(`/api/v1/leasingobjects${QS.query(QS.explode({
        leasingCode,
        leasingObjectCode,
        generation
    }))}`, {
        ...opts
    }));
}
/**
 * Get by leasing
 */
export function getApiV1LeasingobjectsByleasingByLeasingCode(leasingCode: string, generation: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: LeasingObjectModel[];
    }>(`/api/v1/leasingobjects/byleasing/${encodeURIComponent(leasingCode)}${QS.query(QS.explode({
        generation
    }))}`, {
        ...opts
    }));
}
/**
 * Get by leasing object
 */
export function getApiV1LeasingobjectEntriesByleasingobjectByLeasingObjectCode(leasingObjectCode: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: LeasingObjectEntryModel[];
    }>(`/api/v1/leasingobjectEntries/byleasingobject/${encodeURIComponent(leasingObjectCode)}`, {
        ...opts
    }));
}
/**
 * Get all masters
 */
export function getApiV1Masters({ includeExpired }: {
    includeExpired?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: MasterModel[];
    }>(`/api/v1/masters${QS.query(QS.explode({
        includeExpired
    }))}`, {
        ...opts
    }));
}
/**
 * Get a single master by master code
 */
export function getApiV1MastersByMasterCode(masterCode: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: MasterModel;
    } | {
        status: 404;
        data: ProblemDetails;
    }>(`/api/v1/masters/${encodeURIComponent(masterCode)}`, {
        ...opts
    }));
}
export function getApiV1NewaggrementContacts({ leasingCustomerId }: {
    leasingCustomerId?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ContactModel[];
    }>(`/api/v1/newaggrement/contacts${QS.query(QS.explode({
        leasingCustomerId
    }))}`, {
        ...opts
    }));
}
export function getApiV1NewaggrementCustomers(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerModel[];
    }>("/api/v1/newaggrement/customers", {
        ...opts
    }));
}
export function getApiV1NewaggrementCategories(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CategoryModel[];
    }>("/api/v1/newaggrement/categories", {
        ...opts
    }));
}
export function postApiV1NewaggrementCreateNewAggrement(newAggrementRequest: NewAggrementRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/api/v1/newaggrement/CreateNewAggrement", oazapfts.json({
        ...opts,
        method: "POST",
        body: newAggrementRequest
    })));
}
export function getApiV1SearchBySearchString(searchString: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: LeasingModel[];
    }>(`/api/v1/search/${encodeURIComponent(searchString)}`, {
        ...opts
    }));
}

// #region INJECTED PATHS
/* The generated output is not a direct result of oazapfts' default behavior.
* It instead incorporates our custom code, which adds path placeholder properties for MSW mocking, into the output of oazapfts. */
// {{{

const _getApiV1AuthenticateSigninPath = () => defaults.baseUrl + '/api/v1/authenticate/signin';
Object.defineProperty(getApiV1AuthenticateSignin, 'path', { get: _getApiV1AuthenticateSigninPath, set: _getApiV1AuthenticateSigninPath });
/** @path `/api/v1/authenticate/signin` */ 
getApiV1AuthenticateSignin.path = getApiV1AuthenticateSignin.path satisfies string;


const _postApiV1AuthenticateConnectuserPath = () => defaults.baseUrl + '/api/v1/authenticate/connectuser';
Object.defineProperty(postApiV1AuthenticateConnectuser, 'path', { get: _postApiV1AuthenticateConnectuserPath, set: _postApiV1AuthenticateConnectuserPath });
/** @path `/api/v1/authenticate/connectuser` */ 
postApiV1AuthenticateConnectuser.path = postApiV1AuthenticateConnectuser.path satisfies string;


const _getApiV1AuthenticateSignoutPath = () => defaults.baseUrl + '/api/v1/authenticate/signout';
Object.defineProperty(getApiV1AuthenticateSignout, 'path', { get: _getApiV1AuthenticateSignoutPath, set: _getApiV1AuthenticateSignoutPath });
/** @path `/api/v1/authenticate/signout` */ 
getApiV1AuthenticateSignout.path = getApiV1AuthenticateSignout.path satisfies string;


const _getApiV1AuthenticateGetUserNamePath = () => defaults.baseUrl + '/api/v1/authenticate/getUserName';
Object.defineProperty(getApiV1AuthenticateGetUserName, 'path', { get: _getApiV1AuthenticateGetUserNamePath, set: _getApiV1AuthenticateGetUserNamePath });
/** @path `/api/v1/authenticate/getUserName` */ 
getApiV1AuthenticateGetUserName.path = getApiV1AuthenticateGetUserName.path satisfies string;


const _getApiV1AuthenticateGetAuthenticationStatusPath = () => defaults.baseUrl + '/api/v1/authenticate/getAuthenticationStatus';
Object.defineProperty(getApiV1AuthenticateGetAuthenticationStatus, 'path', { get: _getApiV1AuthenticateGetAuthenticationStatusPath, set: _getApiV1AuthenticateGetAuthenticationStatusPath });
/** @path `/api/v1/authenticate/getAuthenticationStatus` */ 
getApiV1AuthenticateGetAuthenticationStatus.path = getApiV1AuthenticateGetAuthenticationStatus.path satisfies string;


const _putCalculatorCreatepathPath = () => defaults.baseUrl + '/calculator/createpath';
Object.defineProperty(putCalculatorCreatepath, 'path', { get: _putCalculatorCreatepathPath, set: _putCalculatorCreatepathPath });
/** @path `/calculator/createpath` */ 
putCalculatorCreatepath.path = putCalculatorCreatepath.path satisfies string;


const _putCalculatorNewleasingByPathPath = () => defaults.baseUrl + '/calculator/newleasing/:path';
Object.defineProperty(putCalculatorNewleasingByPath, 'path', { get: _putCalculatorNewleasingByPathPath, set: _putCalculatorNewleasingByPathPath });
/** @path `/calculator/newleasing/:path` */ 
putCalculatorNewleasingByPath.path = putCalculatorNewleasingByPath.path satisfies string;


const _getCalculatorCalculationresultByCalculationPathPath = () => defaults.baseUrl + '/calculator/calculationresult/:calculationPath';
Object.defineProperty(getCalculatorCalculationresultByCalculationPath, 'path', { get: _getCalculatorCalculationresultByCalculationPathPath, set: _getCalculatorCalculationresultByCalculationPathPath });
/** @path `/calculator/calculationresult/:calculationPath` */ 
getCalculatorCalculationresultByCalculationPath.path = getCalculatorCalculationresultByCalculationPath.path satisfies string;


const _getApiV1DeliveryapprovalPath = () => defaults.baseUrl + '/api/v1/deliveryapproval';
Object.defineProperty(getApiV1Deliveryapproval, 'path', { get: _getApiV1DeliveryapprovalPath, set: _getApiV1DeliveryapprovalPath });
/** @path `/api/v1/deliveryapproval` */ 
getApiV1Deliveryapproval.path = getApiV1Deliveryapproval.path satisfies string;


const _getApiV1DeliveryapprovalByEntryNoPath = () => defaults.baseUrl + '/api/v1/deliveryapproval/:entryNo';
Object.defineProperty(getApiV1DeliveryapprovalByEntryNo, 'path', { get: _getApiV1DeliveryapprovalByEntryNoPath, set: _getApiV1DeliveryapprovalByEntryNoPath });
/** @path `/api/v1/deliveryapproval/:entryNo` */ 
getApiV1DeliveryapprovalByEntryNo.path = getApiV1DeliveryapprovalByEntryNo.path satisfies string;


const _getApiV1DeliveryapprovalByParamAAndParamBPath = () => defaults.baseUrl + '/api/v1/deliveryapproval/:paramA/:paramB';
Object.defineProperty(getApiV1DeliveryapprovalByParamAAndParamB, 'path', { get: _getApiV1DeliveryapprovalByParamAAndParamBPath, set: _getApiV1DeliveryapprovalByParamAAndParamBPath });
/** @path `/api/v1/deliveryapproval/:paramA/:paramB` */ 
getApiV1DeliveryapprovalByParamAAndParamB.path = getApiV1DeliveryapprovalByParamAAndParamB.path satisfies string;


const _postApiV1DeliveryapprovalAcceptPath = () => defaults.baseUrl + '/api/v1/deliveryapproval/accept';
Object.defineProperty(postApiV1DeliveryapprovalAccept, 'path', { get: _postApiV1DeliveryapprovalAcceptPath, set: _postApiV1DeliveryapprovalAcceptPath });
/** @path `/api/v1/deliveryapproval/accept` */ 
postApiV1DeliveryapprovalAccept.path = postApiV1DeliveryapprovalAccept.path satisfies string;


const _postApiV1DeliveryapprovalRejectPath = () => defaults.baseUrl + '/api/v1/deliveryapproval/reject';
Object.defineProperty(postApiV1DeliveryapprovalReject, 'path', { get: _postApiV1DeliveryapprovalRejectPath, set: _postApiV1DeliveryapprovalRejectPath });
/** @path `/api/v1/deliveryapproval/reject` */ 
postApiV1DeliveryapprovalReject.path = postApiV1DeliveryapprovalReject.path satisfies string;


const _getApiV1DocumentsAnnualStatementsPath = () => defaults.baseUrl + '/api/v1/documents/AnnualStatements';
Object.defineProperty(getApiV1DocumentsAnnualStatements, 'path', { get: _getApiV1DocumentsAnnualStatementsPath, set: _getApiV1DocumentsAnnualStatementsPath });
/** @path `/api/v1/documents/AnnualStatements` */ 
getApiV1DocumentsAnnualStatements.path = getApiV1DocumentsAnnualStatements.path satisfies string;


const _getApiV1DocumentsBymasterByMasterCodePath = () => defaults.baseUrl + '/api/v1/documents/bymaster/:masterCode';
Object.defineProperty(getApiV1DocumentsBymasterByMasterCode, 'path', { get: _getApiV1DocumentsBymasterByMasterCodePath, set: _getApiV1DocumentsBymasterByMasterCodePath });
/** @path `/api/v1/documents/bymaster/:masterCode` */ 
getApiV1DocumentsBymasterByMasterCode.path = getApiV1DocumentsBymasterByMasterCode.path satisfies string;


const _getApiV1DocumentsByframeworkByFrameworkCodePath = () => defaults.baseUrl + '/api/v1/documents/byframework/:frameworkCode';
Object.defineProperty(getApiV1DocumentsByframeworkByFrameworkCode, 'path', { get: _getApiV1DocumentsByframeworkByFrameworkCodePath, set: _getApiV1DocumentsByframeworkByFrameworkCodePath });
/** @path `/api/v1/documents/byframework/:frameworkCode` */ 
getApiV1DocumentsByframeworkByFrameworkCode.path = getApiV1DocumentsByframeworkByFrameworkCode.path satisfies string;


const _getApiV1DocumentsByleasingByContractNoPath = () => defaults.baseUrl + '/api/v1/documents/byleasing/:contractNo';
Object.defineProperty(getApiV1DocumentsByleasingByContractNo, 'path', { get: _getApiV1DocumentsByleasingByContractNoPath, set: _getApiV1DocumentsByleasingByContractNoPath });
/** @path `/api/v1/documents/byleasing/:contractNo` */ 
getApiV1DocumentsByleasingByContractNo.path = getApiV1DocumentsByleasingByContractNo.path satisfies string;


const _getApiV1DocumentsByleasingObjectsByContractNoPath = () => defaults.baseUrl + '/api/v1/documents/byleasingObjects/:contractNo';
Object.defineProperty(getApiV1DocumentsByleasingObjectsByContractNo, 'path', { get: _getApiV1DocumentsByleasingObjectsByContractNoPath, set: _getApiV1DocumentsByleasingObjectsByContractNoPath });
/** @path `/api/v1/documents/byleasingObjects/:contractNo` */ 
getApiV1DocumentsByleasingObjectsByContractNo.path = getApiV1DocumentsByleasingObjectsByContractNo.path satisfies string;


const _getApiV1DocumentsByleasingobjectByLeasingObjectCodePath = () => defaults.baseUrl + '/api/v1/documents/byleasingobject/:leasingObjectCode';
Object.defineProperty(getApiV1DocumentsByleasingobjectByLeasingObjectCode, 'path', { get: _getApiV1DocumentsByleasingobjectByLeasingObjectCodePath, set: _getApiV1DocumentsByleasingobjectByLeasingObjectCodePath });
/** @path `/api/v1/documents/byleasingobject/:leasingObjectCode` */ 
getApiV1DocumentsByleasingobjectByLeasingObjectCode.path = getApiV1DocumentsByleasingobjectByLeasingObjectCode.path satisfies string;


const _getApiV1DocumentsDownloadPath = () => defaults.baseUrl + '/api/v1/documents/download';
Object.defineProperty(getApiV1DocumentsDownload, 'path', { get: _getApiV1DocumentsDownloadPath, set: _getApiV1DocumentsDownloadPath });
/** @path `/api/v1/documents/download` */ 
getApiV1DocumentsDownload.path = getApiV1DocumentsDownload.path satisfies string;


const _getApiV1DocumentsDownloadInvoicePath = () => defaults.baseUrl + '/api/v1/documents/downloadInvoice';
Object.defineProperty(getApiV1DocumentsDownloadInvoice, 'path', { get: _getApiV1DocumentsDownloadInvoicePath, set: _getApiV1DocumentsDownloadInvoicePath });
/** @path `/api/v1/documents/downloadInvoice` */ 
getApiV1DocumentsDownloadInvoice.path = getApiV1DocumentsDownloadInvoice.path satisfies string;


const _getApiV1DraftsAllPath = () => defaults.baseUrl + '/api/v1/drafts/all';
Object.defineProperty(getApiV1DraftsAll, 'path', { get: _getApiV1DraftsAllPath, set: _getApiV1DraftsAllPath });
/** @path `/api/v1/drafts/all` */ 
getApiV1DraftsAll.path = getApiV1DraftsAll.path satisfies string;


const _postApiV1DraftsNewPath = () => defaults.baseUrl + '/api/v1/drafts/new';
Object.defineProperty(postApiV1DraftsNew, 'path', { get: _postApiV1DraftsNewPath, set: _postApiV1DraftsNewPath });
/** @path `/api/v1/drafts/new` */ 
postApiV1DraftsNew.path = postApiV1DraftsNew.path satisfies string;


const _postApiV1DraftsUpdatePath = () => defaults.baseUrl + '/api/v1/drafts/update';
Object.defineProperty(postApiV1DraftsUpdate, 'path', { get: _postApiV1DraftsUpdatePath, set: _postApiV1DraftsUpdatePath });
/** @path `/api/v1/drafts/update` */ 
postApiV1DraftsUpdate.path = postApiV1DraftsUpdate.path satisfies string;


const _getApiV1DraftsGetPath = () => defaults.baseUrl + '/api/v1/drafts/get';
Object.defineProperty(getApiV1DraftsGet, 'path', { get: _getApiV1DraftsGetPath, set: _getApiV1DraftsGetPath });
/** @path `/api/v1/drafts/get` */ 
getApiV1DraftsGet.path = getApiV1DraftsGet.path satisfies string;


const _getApiV1DraftsDeletePath = () => defaults.baseUrl + '/api/v1/drafts/delete';
Object.defineProperty(getApiV1DraftsDelete, 'path', { get: _getApiV1DraftsDeletePath, set: _getApiV1DraftsDeletePath });
/** @path `/api/v1/drafts/delete` */ 
getApiV1DraftsDelete.path = getApiV1DraftsDelete.path satisfies string;


const _getApiV1ExpiringagreementsAllnormalPath = () => defaults.baseUrl + '/api/v1/expiringagreements/allnormal';
Object.defineProperty(getApiV1ExpiringagreementsAllnormal, 'path', { get: _getApiV1ExpiringagreementsAllnormalPath, set: _getApiV1ExpiringagreementsAllnormalPath });
/** @path `/api/v1/expiringagreements/allnormal` */ 
getApiV1ExpiringagreementsAllnormal.path = getApiV1ExpiringagreementsAllnormal.path satisfies string;


const _getApiV1ExpiringagreementsAllnormalanoByParamAAndParamBParamPPath = () => defaults.baseUrl + '/api/v1/expiringagreements/allnormalano/:paramA/:paramB/:paramP';
Object.defineProperty(getApiV1ExpiringagreementsAllnormalanoByParamAAndParamBParamP, 'path', { get: _getApiV1ExpiringagreementsAllnormalanoByParamAAndParamBParamPPath, set: _getApiV1ExpiringagreementsAllnormalanoByParamAAndParamBParamPPath });
/** @path `/api/v1/expiringagreements/allnormalano/:paramA/:paramB/:paramP` */ 
getApiV1ExpiringagreementsAllnormalanoByParamAAndParamBParamP.path = getApiV1ExpiringagreementsAllnormalanoByParamAAndParamBParamP.path satisfies string;


const _getApiV1ExpiringagreementsAllayvensPath = () => defaults.baseUrl + '/api/v1/expiringagreements/allayvens';
Object.defineProperty(getApiV1ExpiringagreementsAllayvens, 'path', { get: _getApiV1ExpiringagreementsAllayvensPath, set: _getApiV1ExpiringagreementsAllayvensPath });
/** @path `/api/v1/expiringagreements/allayvens` */ 
getApiV1ExpiringagreementsAllayvens.path = getApiV1ExpiringagreementsAllayvens.path satisfies string;


const _getApiV1ExpiringagreementsAllayvensanoByParamAAndParamBParamPPath = () => defaults.baseUrl + '/api/v1/expiringagreements/allayvensano/:paramA/:paramB/:paramP';
Object.defineProperty(getApiV1ExpiringagreementsAllayvensanoByParamAAndParamBParamP, 'path', { get: _getApiV1ExpiringagreementsAllayvensanoByParamAAndParamBParamPPath, set: _getApiV1ExpiringagreementsAllayvensanoByParamAAndParamBParamPPath });
/** @path `/api/v1/expiringagreements/allayvensano/:paramA/:paramB/:paramP` */ 
getApiV1ExpiringagreementsAllayvensanoByParamAAndParamBParamP.path = getApiV1ExpiringagreementsAllayvensanoByParamAAndParamBParamP.path satisfies string;


const _getApiV1ExpiringagreementsAllhandledPath = () => defaults.baseUrl + '/api/v1/expiringagreements/allhandled';
Object.defineProperty(getApiV1ExpiringagreementsAllhandled, 'path', { get: _getApiV1ExpiringagreementsAllhandledPath, set: _getApiV1ExpiringagreementsAllhandledPath });
/** @path `/api/v1/expiringagreements/allhandled` */ 
getApiV1ExpiringagreementsAllhandled.path = getApiV1ExpiringagreementsAllhandled.path satisfies string;


const _postApiV1ExpiringagreementsExtendanoPath = () => defaults.baseUrl + '/api/v1/expiringagreements/extendano';
Object.defineProperty(postApiV1ExpiringagreementsExtendano, 'path', { get: _postApiV1ExpiringagreementsExtendanoPath, set: _postApiV1ExpiringagreementsExtendanoPath });
/** @path `/api/v1/expiringagreements/extendano` */ 
postApiV1ExpiringagreementsExtendano.path = postApiV1ExpiringagreementsExtendano.path satisfies string;


const _postApiV1ExpiringagreementsExtendPath = () => defaults.baseUrl + '/api/v1/expiringagreements/extend';
Object.defineProperty(postApiV1ExpiringagreementsExtend, 'path', { get: _postApiV1ExpiringagreementsExtendPath, set: _postApiV1ExpiringagreementsExtendPath });
/** @path `/api/v1/expiringagreements/extend` */ 
postApiV1ExpiringagreementsExtend.path = postApiV1ExpiringagreementsExtend.path satisfies string;


const _postApiV1ExpiringagreementsPurchaseanoPath = () => defaults.baseUrl + '/api/v1/expiringagreements/purchaseano';
Object.defineProperty(postApiV1ExpiringagreementsPurchaseano, 'path', { get: _postApiV1ExpiringagreementsPurchaseanoPath, set: _postApiV1ExpiringagreementsPurchaseanoPath });
/** @path `/api/v1/expiringagreements/purchaseano` */ 
postApiV1ExpiringagreementsPurchaseano.path = postApiV1ExpiringagreementsPurchaseano.path satisfies string;


const _postApiV1ExpiringagreementsPurchasePath = () => defaults.baseUrl + '/api/v1/expiringagreements/purchase';
Object.defineProperty(postApiV1ExpiringagreementsPurchase, 'path', { get: _postApiV1ExpiringagreementsPurchasePath, set: _postApiV1ExpiringagreementsPurchasePath });
/** @path `/api/v1/expiringagreements/purchase` */ 
postApiV1ExpiringagreementsPurchase.path = postApiV1ExpiringagreementsPurchase.path satisfies string;


const _postApiV1ExpiringagreementsSaleanoPath = () => defaults.baseUrl + '/api/v1/expiringagreements/saleano';
Object.defineProperty(postApiV1ExpiringagreementsSaleano, 'path', { get: _postApiV1ExpiringagreementsSaleanoPath, set: _postApiV1ExpiringagreementsSaleanoPath });
/** @path `/api/v1/expiringagreements/saleano` */ 
postApiV1ExpiringagreementsSaleano.path = postApiV1ExpiringagreementsSaleano.path satisfies string;


const _postApiV1ExpiringagreementsSalePath = () => defaults.baseUrl + '/api/v1/expiringagreements/sale';
Object.defineProperty(postApiV1ExpiringagreementsSale, 'path', { get: _postApiV1ExpiringagreementsSalePath, set: _postApiV1ExpiringagreementsSalePath });
/** @path `/api/v1/expiringagreements/sale` */ 
postApiV1ExpiringagreementsSale.path = postApiV1ExpiringagreementsSale.path satisfies string;


const _postApiV1ExpiringagreementsAyvensanoPath = () => defaults.baseUrl + '/api/v1/expiringagreements/ayvensano';
Object.defineProperty(postApiV1ExpiringagreementsAyvensano, 'path', { get: _postApiV1ExpiringagreementsAyvensanoPath, set: _postApiV1ExpiringagreementsAyvensanoPath });
/** @path `/api/v1/expiringagreements/ayvensano` */ 
postApiV1ExpiringagreementsAyvensano.path = postApiV1ExpiringagreementsAyvensano.path satisfies string;


const _postApiV1ExpiringagreementsAyvensPath = () => defaults.baseUrl + '/api/v1/expiringagreements/ayvens';
Object.defineProperty(postApiV1ExpiringagreementsAyvens, 'path', { get: _postApiV1ExpiringagreementsAyvensPath, set: _postApiV1ExpiringagreementsAyvensPath });
/** @path `/api/v1/expiringagreements/ayvens` */ 
postApiV1ExpiringagreementsAyvens.path = postApiV1ExpiringagreementsAyvens.path satisfies string;


const _getApiV1FrameworksPath = () => defaults.baseUrl + '/api/v1/frameworks';
Object.defineProperty(getApiV1Frameworks, 'path', { get: _getApiV1FrameworksPath, set: _getApiV1FrameworksPath });
/** @path `/api/v1/frameworks` */ 
getApiV1Frameworks.path = getApiV1Frameworks.path satisfies string;


const _getApiV1FrameworksShortsPath = () => defaults.baseUrl + '/api/v1/frameworks/shorts';
Object.defineProperty(getApiV1FrameworksShorts, 'path', { get: _getApiV1FrameworksShortsPath, set: _getApiV1FrameworksShortsPath });
/** @path `/api/v1/frameworks/shorts` */ 
getApiV1FrameworksShorts.path = getApiV1FrameworksShorts.path satisfies string;


const _getApiV1FrameworksByFrameworkCodePath = () => defaults.baseUrl + '/api/v1/frameworks/:frameworkCode';
Object.defineProperty(getApiV1FrameworksByFrameworkCode, 'path', { get: _getApiV1FrameworksByFrameworkCodePath, set: _getApiV1FrameworksByFrameworkCodePath });
/** @path `/api/v1/frameworks/:frameworkCode` */ 
getApiV1FrameworksByFrameworkCode.path = getApiV1FrameworksByFrameworkCode.path satisfies string;


const _getApiV1FrameworksBymasterByMasterCodePath = () => defaults.baseUrl + '/api/v1/frameworks/bymaster/:masterCode';
Object.defineProperty(getApiV1FrameworksBymasterByMasterCode, 'path', { get: _getApiV1FrameworksBymasterByMasterCodePath, set: _getApiV1FrameworksBymasterByMasterCodePath });
/** @path `/api/v1/frameworks/bymaster/:masterCode` */ 
getApiV1FrameworksBymasterByMasterCode.path = getApiV1FrameworksBymasterByMasterCode.path satisfies string;


const _getApiV1GlnByCustomerNoPath = () => defaults.baseUrl + '/api/v1/gln/:customerNo';
Object.defineProperty(getApiV1GlnByCustomerNo, 'path', { get: _getApiV1GlnByCustomerNoPath, set: _getApiV1GlnByCustomerNoPath });
/** @path `/api/v1/gln/:customerNo` */ 
getApiV1GlnByCustomerNo.path = getApiV1GlnByCustomerNo.path satisfies string;


const _getApiV1GlnBymaindebitorByCustomerNoPath = () => defaults.baseUrl + '/api/v1/gln/bymaindebitor/:customerNo';
Object.defineProperty(getApiV1GlnBymaindebitorByCustomerNo, 'path', { get: _getApiV1GlnBymaindebitorByCustomerNoPath, set: _getApiV1GlnBymaindebitorByCustomerNoPath });
/** @path `/api/v1/gln/bymaindebitor/:customerNo` */ 
getApiV1GlnBymaindebitorByCustomerNo.path = getApiV1GlnBymaindebitorByCustomerNo.path satisfies string;


const _getApiV1LeasingsPath = () => defaults.baseUrl + '/api/v1/leasings';
Object.defineProperty(getApiV1Leasings, 'path', { get: _getApiV1LeasingsPath, set: _getApiV1LeasingsPath });
/** @path `/api/v1/leasings` */ 
getApiV1Leasings.path = getApiV1Leasings.path satisfies string;


const _getApiV1LeasingsByLeasingCodePath = () => defaults.baseUrl + '/api/v1/leasings/:leasingCode';
Object.defineProperty(getApiV1LeasingsByLeasingCode, 'path', { get: _getApiV1LeasingsByLeasingCodePath, set: _getApiV1LeasingsByLeasingCodePath });
/** @path `/api/v1/leasings/:leasingCode` */ 
getApiV1LeasingsByLeasingCode.path = getApiV1LeasingsByLeasingCode.path satisfies string;


const _getApiV1LeasingsByframeworkByFrameworkCodePath = () => defaults.baseUrl + '/api/v1/leasings/byframework/:frameworkCode';
Object.defineProperty(getApiV1LeasingsByframeworkByFrameworkCode, 'path', { get: _getApiV1LeasingsByframeworkByFrameworkCodePath, set: _getApiV1LeasingsByframeworkByFrameworkCodePath });
/** @path `/api/v1/leasings/byframework/:frameworkCode` */ 
getApiV1LeasingsByframeworkByFrameworkCode.path = getApiV1LeasingsByframeworkByFrameworkCode.path satisfies string;


const _getApiV1LeasingsBycustomerByCustomerNumberPath = () => defaults.baseUrl + '/api/v1/leasings/bycustomer/:customerNumber';
Object.defineProperty(getApiV1LeasingsBycustomerByCustomerNumber, 'path', { get: _getApiV1LeasingsBycustomerByCustomerNumberPath, set: _getApiV1LeasingsBycustomerByCustomerNumberPath });
/** @path `/api/v1/leasings/bycustomer/:customerNumber` */ 
getApiV1LeasingsBycustomerByCustomerNumber.path = getApiV1LeasingsBycustomerByCustomerNumber.path satisfies string;


const _postApiV1LeasingsUpdateeanPath = () => defaults.baseUrl + '/api/v1/leasings/updateean';
Object.defineProperty(postApiV1LeasingsUpdateean, 'path', { get: _postApiV1LeasingsUpdateeanPath, set: _postApiV1LeasingsUpdateeanPath });
/** @path `/api/v1/leasings/updateean` */ 
postApiV1LeasingsUpdateean.path = postApiV1LeasingsUpdateean.path satisfies string;


const _postApiV1LeasingsUpdatereferencePath = () => defaults.baseUrl + '/api/v1/leasings/updatereference';
Object.defineProperty(postApiV1LeasingsUpdatereference, 'path', { get: _postApiV1LeasingsUpdatereferencePath, set: _postApiV1LeasingsUpdatereferencePath });
/** @path `/api/v1/leasings/updatereference` */ 
postApiV1LeasingsUpdatereference.path = postApiV1LeasingsUpdatereference.path satisfies string;


const _postApiV1LeasingsUpdateaccountPath = () => defaults.baseUrl + '/api/v1/leasings/updateaccount';
Object.defineProperty(postApiV1LeasingsUpdateaccount, 'path', { get: _postApiV1LeasingsUpdateaccountPath, set: _postApiV1LeasingsUpdateaccountPath });
/** @path `/api/v1/leasings/updateaccount` */ 
postApiV1LeasingsUpdateaccount.path = postApiV1LeasingsUpdateaccount.path satisfies string;


const _getApiV1LeasingsPaymentsPath = () => defaults.baseUrl + '/api/v1/leasings/payments';
Object.defineProperty(getApiV1LeasingsPayments, 'path', { get: _getApiV1LeasingsPaymentsPath, set: _getApiV1LeasingsPaymentsPath });
/** @path `/api/v1/leasings/payments` */ 
getApiV1LeasingsPayments.path = getApiV1LeasingsPayments.path satisfies string;


const _getApiV1LeasingobjectsPath = () => defaults.baseUrl + '/api/v1/leasingobjects';
Object.defineProperty(getApiV1Leasingobjects, 'path', { get: _getApiV1LeasingobjectsPath, set: _getApiV1LeasingobjectsPath });
/** @path `/api/v1/leasingobjects` */ 
getApiV1Leasingobjects.path = getApiV1Leasingobjects.path satisfies string;


const _getApiV1LeasingobjectsByleasingByLeasingCodePath = () => defaults.baseUrl + '/api/v1/leasingobjects/byleasing/:leasingCode';
Object.defineProperty(getApiV1LeasingobjectsByleasingByLeasingCode, 'path', { get: _getApiV1LeasingobjectsByleasingByLeasingCodePath, set: _getApiV1LeasingobjectsByleasingByLeasingCodePath });
/** @path `/api/v1/leasingobjects/byleasing/:leasingCode` */ 
getApiV1LeasingobjectsByleasingByLeasingCode.path = getApiV1LeasingobjectsByleasingByLeasingCode.path satisfies string;


const _getApiV1LeasingobjectEntriesByleasingobjectByLeasingObjectCodePath = () => defaults.baseUrl + '/api/v1/leasingobjectEntries/byleasingobject/:leasingObjectCode';
Object.defineProperty(getApiV1LeasingobjectEntriesByleasingobjectByLeasingObjectCode, 'path', { get: _getApiV1LeasingobjectEntriesByleasingobjectByLeasingObjectCodePath, set: _getApiV1LeasingobjectEntriesByleasingobjectByLeasingObjectCodePath });
/** @path `/api/v1/leasingobjectEntries/byleasingobject/:leasingObjectCode` */ 
getApiV1LeasingobjectEntriesByleasingobjectByLeasingObjectCode.path = getApiV1LeasingobjectEntriesByleasingobjectByLeasingObjectCode.path satisfies string;


const _getApiV1MastersPath = () => defaults.baseUrl + '/api/v1/masters';
Object.defineProperty(getApiV1Masters, 'path', { get: _getApiV1MastersPath, set: _getApiV1MastersPath });
/** @path `/api/v1/masters` */ 
getApiV1Masters.path = getApiV1Masters.path satisfies string;


const _getApiV1MastersByMasterCodePath = () => defaults.baseUrl + '/api/v1/masters/:masterCode';
Object.defineProperty(getApiV1MastersByMasterCode, 'path', { get: _getApiV1MastersByMasterCodePath, set: _getApiV1MastersByMasterCodePath });
/** @path `/api/v1/masters/:masterCode` */ 
getApiV1MastersByMasterCode.path = getApiV1MastersByMasterCode.path satisfies string;


const _getApiV1NewaggrementContactsPath = () => defaults.baseUrl + '/api/v1/newaggrement/contacts';
Object.defineProperty(getApiV1NewaggrementContacts, 'path', { get: _getApiV1NewaggrementContactsPath, set: _getApiV1NewaggrementContactsPath });
/** @path `/api/v1/newaggrement/contacts` */ 
getApiV1NewaggrementContacts.path = getApiV1NewaggrementContacts.path satisfies string;


const _getApiV1NewaggrementCustomersPath = () => defaults.baseUrl + '/api/v1/newaggrement/customers';
Object.defineProperty(getApiV1NewaggrementCustomers, 'path', { get: _getApiV1NewaggrementCustomersPath, set: _getApiV1NewaggrementCustomersPath });
/** @path `/api/v1/newaggrement/customers` */ 
getApiV1NewaggrementCustomers.path = getApiV1NewaggrementCustomers.path satisfies string;


const _getApiV1NewaggrementCategoriesPath = () => defaults.baseUrl + '/api/v1/newaggrement/categories';
Object.defineProperty(getApiV1NewaggrementCategories, 'path', { get: _getApiV1NewaggrementCategoriesPath, set: _getApiV1NewaggrementCategoriesPath });
/** @path `/api/v1/newaggrement/categories` */ 
getApiV1NewaggrementCategories.path = getApiV1NewaggrementCategories.path satisfies string;


const _postApiV1NewaggrementCreateNewAggrementPath = () => defaults.baseUrl + '/api/v1/newaggrement/CreateNewAggrement';
Object.defineProperty(postApiV1NewaggrementCreateNewAggrement, 'path', { get: _postApiV1NewaggrementCreateNewAggrementPath, set: _postApiV1NewaggrementCreateNewAggrementPath });
/** @path `/api/v1/newaggrement/CreateNewAggrement` */ 
postApiV1NewaggrementCreateNewAggrement.path = postApiV1NewaggrementCreateNewAggrement.path satisfies string;


const _getApiV1SearchBySearchStringPath = () => defaults.baseUrl + '/api/v1/search/:searchString';
Object.defineProperty(getApiV1SearchBySearchString, 'path', { get: _getApiV1SearchBySearchStringPath, set: _getApiV1SearchBySearchStringPath });
/** @path `/api/v1/search/:searchString` */ 
getApiV1SearchBySearchString.path = getApiV1SearchBySearchString.path satisfies string;


// }}}
 // #endregion 